<template>
  <div class="item" id="cardInfo.id" >
      <el-image v-on:click="directToPage" :src="cardInfo.icon" style="width: 260px;cursor: pointer;" fit="contain"></el-image>
  </div>
</template>
<script>
  export default {
    props: [
      'cardInfo'
    ],
    methods: {
      directToPage () {
        window.open(this.cardInfo.link, '_self')
      }
    }
  }
</script>
<style scoped lang="scss">
  @import "../assets/style/mixin";

  .item {
    background-color: #FFFFFf;
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
    align-content: center;
    padding-top: 30px;
    transition: 1s;
    -moz-transition: 1s; /* Firefox 4 */
    -webkit-transition: 1s; /* Safari and Chrome */
    -o-transition: 1s; /* Opera */
    .img-box {
      margin-bottom: 1rem;
      @extend %block-center
    }
  }
  .item:hover{
    transform:scale(1.1, 1.1);
    -ms-transform:scale(1.1, 1.1); 	/* IE 9 */
    -moz-transform:scale(1.1, 1.1); 	/* Firefox */
    -webkit-transform:scale(1.1, 1.1); /* Safari 和 Chrome */
    -o-transform:scale(1.1, 1.1);
  }
</style>



// WEBPACK FOOTER //
// bottomcard.vue?c71cfc9e